<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item>好物圈管理</el-breadcrumb-item> -->
        <el-breadcrumb-item>好物圈管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="团名称">
          <el-input size="small" v-model="formInline.introduce" clearable placeholder="请输入团名称"></el-input>
        </el-form-item>
        <el-form-item label="团长姓名">
          <el-input size="small" v-model="formInline.userName" clearable placeholder="请输入团长姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
          size="small"
          v-model="dateRange"
          type="daterange"
          @change="dateChange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column prop="introduce" label="团名称">
        </el-table-column>
        <el-table-column prop="name" label="商品名称">
        </el-table-column>
        <el-table-column prop="userName" label="团长姓名">
        </el-table-column>
        <el-table-column prop="phone" label="团长手机号">
        </el-table-column>
        <!-- <el-table-column sortable prop="useNum" label="分享次数">
        </el-table-column> -->
        <el-table-column sortable prop="analyse" label="查看该商品人数">
        </el-table-column>
        <el-table-column sortable prop="orderQuantity" label="交易人数">
            <!-- <template slot-scope="scope">
               <el-tag class="pointer" @click="handleEdit(scope.$index, scope.row)">{{scope.row.useNum}}</el-tag>
            </template> -->
        </el-table-column>
        <el-table-column sortable prop="totalAmount" label="交易金额">
        </el-table-column>
        <el-table-column prop="createDate" label="开团时间">
          <template slot-scope="scope">
            <div>{{scope.row.createDate|timestampToTime}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" >
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>
  
  <script>
  import { addDictType, delDictType, editDictType, leaderTeamList } from '@/api/system'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        dateRange:null,
        activeText:['禁用','启用'],
        editForm: {
          status:'1',
          cnName:''
        },
        // rules表单验证
        rules: {
          cnName: [
            { required: true, message: '请输入类型名称', trigger: 'blur' }
          ],
        },
        formInline: {
          page: 1,
          limit: 10,
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        leaderTeamList(parameter).then(res => {
            this.loading = false
            if (res.code != 200) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page=1
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'
          this.editForm.status = row.status
          this.editForm.cnName = row.cnName
          this.editForm.id = row.id
        } else {
          this.title = '添加'
          this.editForm.status = '1'
          this.editForm.cnName = ''
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            let subType = this.title == '修改'?editDictType:addDictType
            subType(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.rsp_code==200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: `${this.title}成功！`
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error(`${this.title}失败，请稍后再试！`)
              })
          } else {
            return false
          }
        })
      },
      // 删除公司
      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delDictType({id:row.id})
              .then(res => {
                if (res.rsp_code==200) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      dateChange(v){
        console.log(v);
        if(!!v){
          this.formInline.beginTime	= v[0]
          this.formInline.endTime	= v[1]
        }
        else{
          this.formInline.beginTime	= null
          this.formInline.endTime	= null
        }
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      }
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .prople_info{
    height: 100%;
    padding: 30px;
  }
  </style>
  
   


// WEBPACK FOOTER //
// src/views/shareShopping/list.vue